// @flow
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import UserProfileField from '../UserProfileField';
import type { UserProfile } from '../../typeDefinitions/userProfile';

type Props = {
    sketchTech: UserProfile,
    reviewer: UserProfile,
}

const SketchOrderAssignments = (props: Props) => {
    return (
        <CardContent>
            <Grid container>
                <Grid item xs={6}>
                    <UserProfileField
                        label="Sketch Tech"
                        user={props.sketchTech}
                    />
                </Grid>
                <Grid item xs={6}>
                    <UserProfileField
                        label="Reviewer"
                        user={props.reviewer}
                    />
                </Grid>
            </Grid>
        </CardContent>
    );
};
 
export default SketchOrderAssignments;
